import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import {
  FulfillmentGroupData,
  shouldUseVerifiedDestinationAddress,
} from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";

const catalogEntry = fgColumnEntries["postal-code"];

function getPostalCode(row: FulfillmentGroupData, autoCleanAddresses: boolean) {
  if (shouldUseVerifiedDestinationAddress(row, autoCleanAddresses)) {
    return (
      row?.verifiedDestinationAddress?.zip ?? row?.destinationAddress?.zip ?? ""
    );
  }
  return row?.destinationAddress?.zip ?? "";
}

export const PostalCodeColumn = (
  autoCleanAddresses: boolean,
): Column2<FulfillmentGroupData> => ({
  key: catalogEntry.key,
  title: catalogEntry.title,
  alignment: ColumnAlignment.LEFT,
  renderNormalCell: ({ row }) => (
    <RedoTableTextCell text={getPostalCode(row, autoCleanAddresses)} />
  ),
  width: catalogEntry.defaultWidth,
  sort: catalogEntry.sortDirection,
  hidden: true,
});
